import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface GroupElement extends GroupBase {
  groupTranslationLabel: string;
  itemsCount: number;
}

export interface GroupBase {
  group?: any;
  groupIndex: number;
  fullWidth: boolean;
  visible: boolean;
}

export type ElementWithGroupInfo<T, K, R> = (T & K) | R;

export function isGroupElement<T>(obj: any): obj is GroupElement {
  if ((obj as GroupElement).groupTranslationLabel) {
    return true;
  }
  return false;
}

export const addFullWidthGroups =
  <T>(groupFieldName: keyof T, translatePrefix: string, sectionsToggleStatus: Record<string, boolean>) =>
  (source: Observable<Array<T>>) =>
    source.pipe(map(items => buildGroups(groupFieldName, translatePrefix, items, sectionsToggleStatus)));

function buildGroups<T>(
  groupFieldName: keyof T,
  translatePrefix: string,
  items: Array<T>,
  sectionsToggleStatus: Record<string, boolean>,
): Array<ElementWithGroupInfo<T, GroupBase, GroupElement>> {
  let lastGroup = null;
  let groupIndex = 0;
  const newItems: Array<ElementWithGroupInfo<T, GroupBase, GroupElement>> = [];
  for (const item of items) {
    const group = item[groupFieldName];
    if (lastGroup !== group) {
      const groupItem: ElementWithGroupInfo<T, GroupBase, GroupElement> = {
        group,
        groupTranslationLabel: `${translatePrefix}.${group}`,
        groupIndex: ++groupIndex,
        fullWidth: true,
        visible: true,
        itemsCount: 0,
      };
      newItems.push(groupItem);
      lastGroup = group;
      groupIndex++;
    }
    newItems.push({
      ...item,
      groupIndex: groupIndex,
      fullWidth: false,
      visible: sectionsToggleStatus[group] ?? false,
    });
  }
  return newItems;
}
